export const NAVIGATION_VARIANTS = {
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
} as const;
//primary navigation is global header
//secondary and tertiary are for navigation within page

export type NavigationKeyVariants = keyof typeof NAVIGATION_VARIANTS;

export type NavigationVariants =
  typeof NAVIGATION_VARIANTS[NavigationKeyVariants];
